import * as React from 'react';
import Link from '@mui/material/Link';


const rsvpLink = "https://www.aisleplanner.com/app/v2/our-wedding/courtandandrew/rsvp";

type RSVPLinkProps = {
  linkText?: string,
  underline?: "hover" | "always" | "none"
};

const defaultProps: RSVPLinkProps = {
  linkText: "Click HERE to RSVP",
  underline: "hover"
};

export default function RSVPLink(linkProps: RSVPLinkProps = defaultProps) {
  return (
          <Link href={rsvpLink} 
            underline={linkProps.underline ? linkProps.underline : defaultProps.underline}
            >
            {linkProps.linkText ? linkProps.linkText : defaultProps.linkText}
          </Link>
  );
}